import { ApiService, ApiServiceInterface } from "../../../../../core";
import { AdmPanelContainerController, AdmPanelLoadResponse } from "../interfaces";

export class AdmPanelContainerControllerImpl implements AdmPanelContainerController {
    private api: ApiServiceInterface;

    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async onLoad(): Promise<AdmPanelLoadResponse> {
        try {
            const response: AdmPanelLoadResponse = await this.api.get('/user-status');
            return response;
        } catch (error) {
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                throw (error?.response?.status.toString());
            } else {
                throw new Error("Falha ao requisitar os dados para o Dashboard");
            }
        }
    }
}